
import axios from 'axios';

const loginUrl = process.env.REACT_APP_LOGIN_URL

export async function ManualLogin(email,password,props) {	
        
    const data = await axios({
        url: loginUrl,
        method: 'post',
        headers: {
        'Content-Type': 'application/json',
        },
        data: {
        query: `
        mutation login($emailOrId: String!, $password: String!){
            login(emailOrId: $emailOrId, password: $password) {
            token
            user {
                id
                firstName
                lastName
                activeRole
                roles
                additionalInfo
                language
            }
            }
        }
        `,
        variables: {
            emailOrId: email,
            password: password
            
        }
        },
    
        
    });
   
    const data12 = data.data.data
    return data12
    
    }

    export async function googleLogin(token) {	
        console.log("in google login")
    const data = await axios({
        url: loginUrl,
        method: 'post',
        headers: {
        'Content-Type': 'application/json',
        },
        data: {
            query: `mutation googleLogin($token: String!){
                googleLogin(token: $token) {
                token
                user {
                    id
                    firstName
                    lastName
                    activeRole
                    roles
                    additionalInfo
                    language
                    email
                }
                }
            }`,
        variables: {
            token: token
            
        }
        },
        
    
        
    });
    const data12 = data.data.data
    return data12
    
    }